// extracted by mini-css-extract-plugin
module.exports = {"addPage":"Add_addPage__FqdZX","addContent":"Add_addContent__1bAPU","inputWrapper":"Add_inputWrapper__2ZdOi","results":"Add_results__2ybxW"};